export default __webpack_public_path__ + "static/media/logo-ams.2db126ef.svg";